import { getRequest, postRequest, getcontractIdNumber } from './api'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm = searchTerm || '%20';
  orderBy = orderBy || '%20';
  if (!searchTerm.includes('ContractID'))
    searchTerm = `${searchTerm}, ContractID:${getcontractIdNumber()},`
  // contractId query: the backend also returns the contract's CLINs without a
  // budget as zero-amount rows ("CLIN and Budget" view).
  return getRequest(
    `clinBudget/get-list/${parseInt(size, 10) || 10}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy || '%20'}?contractId=${getcontractIdNumber()}`,
  )
}

export async function find(id) {
  return getRequest(`clinBudget/edit/${id}`)
}

export async function save(values) {
  return postRequest(`clinBudget/save`, values)
}

export async function remove(values) {
  return postRequest(`clinBudget/delete`, values)
}

export async function getWorkOrderBudgets(workOrderID) {
  const cs = getcontractIdNumber()

  return getRequest(`clinBudget/get-budget-view/${workOrderID}/${cs}`)
}

export async function getClinBudgetReport() {
  const cs = getcontractIdNumber()
  return getRequest(`clinBudget/clinbudgetreport/${cs}`)
}

// Project totals of the "CLIN and Budget" page: budget - used - reserved (approved
// proposals not yet used) = remaining. The same figure the server approval check
// (ProposalService.Approve) uses - the approval screen's pre-check and the customer
// dashboard read it from here. hasBudget = the project has a budget row (without one
// the server skips the check).
export async function getContractBudgetSummary(contractId) {
  try {
    const result = await getRequest(
      `clinBudget/get-list/1000/0/ContractID:${contractId}/%20?contractId=${contractId}`,
    )
    if (result && result.items) {
      const sumOf = field => result.items.reduce((sum, item) => sum + (item[field] || 0), 0)
      return {
        totalBudget: sumOf('amount'),
        usedBudget: sumOf('usedBudget'),
        reservedBudget: sumOf('reservedBudget'),
        remainingBudget: sumOf('remainingBudget'),
        hasBudget: result.items.some(item => item.clinBudgetID > 0),
      }
    }
    return null
  } catch (e) {
    console.error('Failed to get budget summary:', e)
    return null
  }
}
